// import UIkit from 'uikit'
// import Snap from 'snapsvg-cjs'

export default {
  init() {

    $('.layout-timeline .line-overlay .line-content .uk-icon').on('dblclick', function () {
      $(this).addClass('may4th');
      dataLayer.push({'event': 'deathstar'});
    }).on('animationend', function () {
      $(this).removeClass('may4th');
      $(this).closest('article.timeline').find('.uk-card').addClass('boom').on('animationend', function () {
        $(this).removeClass('boom');
      })
    });

    //
    // if ($('.animated-m').length > 0) {
    //
    //
    //
    //   var svg = document.getElementById('helix');
    //   var s = Snap(svg);
    //   var simpleCup = Snap.select('#straight');
    //   var fancyCup = Snap.select('#curve');
    //   var simpleCupPoints = simpleCup.node.getAttribute('d');
    //   var fancyCupPoints = fancyCup.node.getAttribute('d');
    //   var startLines = function () {
    //     $('.line').addClass('active');
    //     setTimeout(function () {
    //       endLines();
    //     }, 1000);
    //   };
    //   var endLines = function () {
    //     $('.line').removeClass('active');
    //     setTimeout(function () {
    //       toSimpleEnd();
    //     }, 1000);
    //   };
    //   var startM = function () {
    //     if ($('.animated-m').hasClass('ready')) {
    //       $('.animated-m').removeClass('ready');
    //       $('.animated-m').addClass('active');
    //       $('svg.logo g#favicon').addClass('active');
    //       setTimeout(function () {
    //         toSimple();
    //       }, 250);
    //     }
    //   };
    //   var restartM = function () {
    //     $('.animated-m').removeClass('active');
    //     $('svg.logo g#favicon').removeClass('active');
    //     $('.animated-m').addClass('ready');
    //
    //   };
    //   var toFancy = function () {
    //     simpleCup.animate({d: fancyCupPoints}, 250, mina.linear, startLines);
    //   }
    //   var toSimple = function () {
    //     simpleCup.animate({d: simpleCupPoints}, 250, mina.linear, toFancy);
    //   }
    //   var toSimpleEnd = function () {
    //     simpleCup.animate({d: simpleCupPoints}, 250, mina.linear, restartM);
    //   }
    //   s.click(function () {
    //     startM();
    //   });
    //   UIkit.scrollspy('.animated-m', {
    //     cls: 'in-view',
    //     delay: 1000,
    //     hidden: false,
    //     repeat: true,
    //   });
    //   UIkit.util.on('.animated-m', 'inview', function () {
    //     startM();
    //   });
    //   $('.animated-m').addClass('ready');
    //
    // }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/companyMilestones.js